import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import { withI18n } from '../../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';

type Props = {
  discountAmount: number;
  i18n: I18nService;
};

const PriceCugDiscount = ({ discountAmount, i18n }: Props) => (
  <BpkText textStyle={TEXT_STYLES.label1} color={TEXT_COLORS.textError}>
    {`-${i18n.formatCurrencyFull(discountAmount)}`}
  </BpkText>
);

export default withI18n(PriceCugDiscount);
